import React, { useEffect, useState } from "react";
import "../assets/css/Accounts.css";
import CustomersLeadsPage from "./CustomersLeadsPage";
import axiosInstance from "../components/api/axiosInstance";
import { canPerformActionOnPage, PAGES, ACTIONS } from "../utils/roleAccess";
import { getAuthItem } from "../utils/authStorage";

function Customers({ customers = [], onViewLead, onEditLead, onDeleteTenant, onAddTenantClick, onLoginFixesClick }) {
  const role = (() => {
    try {
      const u = getAuthItem("user");
      if (!u) return null;
      const user = JSON.parse(u);
      const primaryRole = Array.isArray(user.roles) && user.roles.length > 0 ? user.roles[0] : null;
      return (
        (primaryRole && (primaryRole.role_name || primaryRole.name || primaryRole.role)) ||
        user.role_name ||
        user.role ||
        null
      );
    } catch {
      return null;
    }
  })();
  const canAdd = canPerformActionOnPage(PAGES.TENANTS, ACTIONS.ADD, role);
  const canEdit = canPerformActionOnPage(PAGES.TENANTS, ACTIONS.EDIT, role);
  const canDelete = canPerformActionOnPage(PAGES.TENANTS, ACTIONS.DELETE, role);
  const [domains, setDomains] = useState([]);
  const [services, setServices] = useState(["All Services"]);
  const [servicesData, setServicesData] = useState([]);
  const [allCities, setAllCities] = useState([]);
  const [loadingCities, setLoadingCities] = useState(true);

  useEffect(() => {
    const fetchDomains = async () => {
      try {
        const res = await axiosInstance.get("/domains");
        const raw = Array.isArray(res.data)
          ? res.data
          : Array.isArray(res.data?.data)
            ? res.data.data
            : [];
        const mapped = raw
          .map((d) => ({
            id: d.Domain_Id ?? d.domain_id ?? d.id,
            name: d.Domain_Name ?? d.domain_name ?? d.name ?? ""
          }))
          .filter((d) => d.id != null && d.name.trim() !== "");
        setDomains(mapped);
      } catch (err) {
        console.error("Error fetching domains for customers list:", err);
        setDomains([]);
      }
    };
    fetchDomains();
  }, []);
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await axiosInstance.get("/service/categories");
        const raw = Array.isArray(res.data)
          ? res.data
          : Array.isArray(res.data?.data)
            ? res.data.data
            : [];
        const flatNames = raw.flatMap((cat) =>
          Array.isArray(cat.subcategories)
            ? cat.subcategories
                .map((sub) => sub.subcategory_name || sub.Subcategory_Name)
                .filter(Boolean)
            : []
        );
        setServices(["All Services", ...flatNames.sort()]);
        setServicesData(raw);
      } catch (err) {
        console.error("Error fetching services for customers list:", err);
        setServices(["All Services"]);
        setServicesData([]);
      }
    };
    fetchServices();
  }, []);

  useEffect(() => {
    const fetchCities = async () => {
      setLoadingCities(true);
      try {
        const res = await axiosInstance.get("/cities");
        const raw = Array.isArray(res.data)
          ? res.data
          : Array.isArray(res.data?.data)
            ? res.data.data
            : [];
        const mapped = raw
          .map((c) => ({
            city_id: c.city_id ?? c.City_Id ?? c.id,
            city_name: c.city_name ?? c.City_Name ?? c.name ?? "",
            state_id: c.state_id ?? c.State_Id ?? c.stateId ?? null
          }))
          .filter((c) => c.city_id != null && String(c.city_name || "").trim() !== "");
        setAllCities(mapped);
      } catch (err) {
        console.error("Error fetching cities for customers list:", err);
        setAllCities([]);
      } finally {
        setLoadingCities(false);
      }
    };
    fetchCities();
  }, []);

  return (
    <div className="accounts-container">
      <div className="main-card">
        <CustomersLeadsPage
          customers={customers}
          services={services}
          servicesData={servicesData}
          allCities={allCities}
          loadingCities={loadingCities}
          domains={domains}
          onViewLead={onViewLead}
          onEditLead={canEdit ? onEditLead : undefined}
          onDeleteTenant={canDelete ? onDeleteTenant : undefined}
          onAddTenantClick={canAdd ? onAddTenantClick : undefined}
          onLoginFixesClick={canEdit ? onLoginFixesClick : undefined}
        />
      </div>
    </div>
  );
}

export default Customers;

